import BaseModel from '../../../util/model';

export default class Model extends BaseModel {
  constructor(component: React.Component) {
    super(component, {});
  }
}
